const $ = jQuery.noConflict();

'use strict';
const TabsSwitcher = {
	/**
	 * @description Cache DOM elements and strings
	 * @type {object}
	 */

	$domTabs: $('.js-tabs'),
	$domTabBtns: $('.js-tabs-switcher-btn'),
	classActive: 'is-active',
	classFirstTab: 'first-tab-active',
	classSecondTab: 'second-tab-active',

	/** @description Initialize */
	init: function() {
		this.bindLoadMore();

		if (!TabsSwitcher.$domTabs.length) return;

		this.bindTabSwitching();
	},

	/**
	 * @description Bind tab switching functionality
	 */
	bindTabSwitching: function() {
		TabsSwitcher.$domTabBtns.on('click', function(e) {
			e.preventDefault();

			const $btn = $(this);
			const tabName = $btn.data('tab');
			const $TabsSwitcher = $btn.closest(TabsSwitcher.$domTabs);

			// Remove is-active from all buttons
			TabsSwitcher.$domTabBtns.removeClass(TabsSwitcher.classActive);
			// Add is-active to clicked button
			$btn.addClass(TabsSwitcher.classActive);

			// Remove all tab classes from parent
			TabsSwitcher.$domTabs.removeClass('first-tab-active second-tab-active');

			// Add appropriate class based on selected tab
			if (tabName === 'first-tab') {
				$TabsSwitcher.addClass('first-tab-active');
			} else if (tabName === 'second-tab') {
				$TabsSwitcher.addClass('second-tab-active');
			}
		});
	},

	/**
	 * @description Bind "Load more" functionality
	 */
	bindLoadMore: function() {
		$(document).on('click', '.js-load-more', function(e) {
			e.preventDefault();

			const $btn = $(this);

			if ($btn.data('shown') === undefined || $btn.data('total') === undefined) {
				return;
			}
			const $tabContent = $btn.closest('.tabs-switcher__tab-content, .media-list__tab-content, .media-list');
			const $items = $tabContent.find('.media-list__item');

			const shown = parseInt($btn.data('shown'), 10);
			const total = parseInt($btn.data('total'), 10);
			const step = parseInt($btn.data('step'), 10) || 10;

			const next = shown + step;

			$items.each(function() {
				const index = parseInt($(this).data('index'), 10);
				if (index < next) {
					$(this).show();
				}
			});

			$btn.data('shown', next);

			const remaining = total - next;
			const $counter = $btn.find('.btn__counter');

			if (remaining > 0) {
				$counter.text(Math.min(step, remaining) + ' more');
			} else {
				$btn.remove();
			}
		});
	}
};
export default TabsSwitcher;
